module.exports = __webpack_public_path__ + "static/media/sn.0dd23464.svg";